import { useMutation } from 'react-query';
import { useQuickUploadFile } from 'contexts/QuickUploadFile';
import { AnchorAPI } from '../../modules/AnchorAPI';

function useUploadFileMultipart() {
  const { setQuickUploadFile } = useQuickUploadFile();
  const { mutate, status } = useMutation(
    ({
      file,
      onProgress,
      onError,
    }: {
      file: File;
      onProgress: (xhr: XMLHttpRequest, loaded: number, total: number) => void;
      onError: () => void;
    }) => {
      return AnchorAPI.uploadFileMultipart({
        file,
        onProgress,
        onError,
      });
    },
    {
      onSuccess: () => {
        setQuickUploadFile(null);
      },
    }
  );

  return { uploadFileMultipart: mutate, uploadFileMultipartStatus: status };
}

export { useUploadFileMultipart };
